<template>
  <div class="min-h-full relative flex flex-col bg-gray-100">
    <nav class="bg-white">
      <ul class="flex">
        <li class="px-5 py-3 uppercase tracking-wider bg-blue-400 text-white">
          Segment Settings:
        </li>
        <li>
          <router-link
            :to="{ name: 'segment-admin-general' }"
            class="block px-8 py-3"
            active-class="bg-gray-100"
            >General</router-link
          >
        </li>
        <li>
          <router-link
            :to="{ name: 'segment-admin-campaigns' }"
            class="block px-8 py-3"
            active-class="bg-gray-100"
            >Campaigns</router-link
          >
        </li>
        <li>
          <router-link
            :to="{ name: 'segment-admin-schema' }"
            class="block px-8 py-3"
            active-class="bg-gray-100"
            >Custom Parameters</router-link
          >
        </li>
        <li>
          <router-link
            :to="{ name: 'segment-admin-export' }"
            class="block px-8 py-3"
            active-class="bg-gray-100"
            >Export</router-link
          >
        </li>
      </ul>
    </nav>
    <div class="flex-1 bg-gray-100 p-16">
      <div v-if="fetchingSegments" class="text-blue-400">
        <base-loading class="block text-3xl" />
        Loading
      </div>
      <router-view v-else />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      fetchingSegments: (state) => state.company.segment.fetchingList,
    }),
  },
};
</script>
